module.exports = __webpack_public_path__ + "img/ts11.2148f553.png";